import { render, staticRenderFns } from "./ExchangeIcon.vue?vue&type=template&id=5541258c&"
import script from "./ExchangeIcon.vue?vue&type=script&lang=js&"
export * from "./ExchangeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports